// @flow

// #region imports
import React from 'react';
import logo from '../../../assets/snb_ic.png'
import loginBtn from '../../../assets/ic_loginarrow.png'
import Header from '../../../components/Common/Header'
import Footer from '../../../components/Common/Footer'
import OtpInput from '../../../components/OtpInput/OtpInput';

// #endregion
class SubmitOTP extends React.Component<any> {

  handleChangeOTP(value) {
    this.props.handleChangeOTP(value)
  }

  verifyOTP() {
    this.props.verifyOTP()
  }

  resendOTP(){
    this.props.resendOTP()
  }

  changePhoneNumber(){
    this.props.changePhoneNumber()
  }

  render() {
    return (
      <div className="login-container-width main background">
        <Header />
        <div className="row Mb-2">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <h2 className="login-txt">Enter OTP</h2>
          </div>
        </div>

        <div className="row Mb-1">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <p> Sent OTP via SMS to number +91 {this.props.phoneNumber}
              <span className="highlight-txt-num" onClick={this.changePhoneNumber.bind(this)}> change number</span>
            </p>
          </div>
        </div>

        <div className="row Mb-2">
          <div className="col-sm-12 col-md-12">
              <OtpInput
                value={this.props.otp}
                onChange={this.handleChangeOTP.bind(this)}
                numInputs={6}
                shouldAutoFocus={true}
                hasErrored={true}
                isInputNum={true}
              />
          </div>
        </div>

        <div className="row Mb-1 Mb-bottom">
          <div className="col-sm-12 col-md-12 col-lg-12 Otp-text">
            <span className="terms highlight-txt-num">
              <a onClick={this.resendOTP.bind(this)} >Resend OTP</a>
            </span>
          </div>
        </div>

        <div className="row errTxtRow">
          {this.props.errMsg !== "" ?
              <div className="col-md-12 col-lg-12 alignCen errTxt">
                {this.props.errMsg}
              </div>
            : null}
        </div> 

        <div className="row Mb-1">
          <div className="col-sm-12 col-md-12 col-lg-12 alignCen">
            <img src={loginBtn} className="submitBtImage" onClick={this.verifyOTP.bind(this)} />
          </div>
        </div>

       <Footer />
      </div>
    );
  }
}

export default SubmitOTP;
